var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{domProps:{"value":_vm.value[_vm.field.id]},on:{"input":function($event){return _vm.updateValue($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }